import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { useDebounce } from 'stimulus-use';
import { getCsrfToken } from '../../utils/dev';
/*
 * Description
 * -------
 *
 * Handles login.
 * Must be used on form element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * path - (required) - API endpoint to login with Fourthwall
 *
 * Usage
 * -------
 *
 * <form
 *   data-controller="login-with-fourthwall"
 *   data-login-with-fourthwall-path-value="https://example.com"
 * >
 *   <input
 *     name="email"
 *     type="email"
 *     data-action="blur->login#login input->login#login"
 *   />
 *   <input name="password" type="password" />
 *   <button type="submit">Login</button>
 * </form>
 */
export class LoginWithFourthwall extends Controller {
    static values = { path: String };
    static debounces = ['login'];
    connect() {
        useDebounce(this, {
            wait: 300,
        });
    }
    async login(e) {
        if (!(e.target instanceof HTMLInputElement))
            return;
        const response = await fetch(this.pathValue, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'text/vnd.turbo-stream.html',
                'X-CSRF-Token': getCsrfToken(),
            },
            body: JSON.stringify({ email: e.target.value }),
        });
        if (response.ok) {
            response.text().then(Turbo.renderStreamMessage);
        }
    }
}
